import { createReducer } from 'reduxsauce';
import { Types } from './actions';
import { resetClient } from '@/data/datasources/graphql/apiClient';

const INITIAL_STATE = {
  isSimulator: false
};

const activeSimulator = (state: any, action: any) => ({
  ...state,
  isSimulator: true, // este es el flag que identificará si nos encontramos en modo simulacion
  user: action.user, // usuario logueado
  userSimulated: action.userSimulated, // usuario que estoy simulando
  firstNameUserSimulated: action.firstNameUserSimulated
});

const inactiveSimulator = (state: any) => {
  resetClient();
  return {
    ...state,
    isSimulator: false,
    user: null,
    userSimulated: null,
    firstNameUserSimulated: null
  };
};

const simulatorWarningOn = (state: any) => ({
  ...state,
  showWarning: true
});

const simulatorWarningOff = (state: any) => ({
  ...state,
  showWarning: false
});

export default createReducer(INITIAL_STATE, {
  [Types.ACTIVE_SIMULATOR]: activeSimulator,
  [Types.INACTIVE_SIMULATOR]: inactiveSimulator,
  [Types.SIMULATOR_WARNING_ON]: simulatorWarningOn,
  [Types.SIMULATOR_WARNING_OFF]: simulatorWarningOff
});
